<template>
  <div>
    <nav class="navbar is-primary">
      <div class="container is-fullhd">
        <div class="navbar-brand">
          <router-link
            :to="{ name: 'home' }"
            :active-class="'none'"
            class="navbar-item"
          >
            <b style="font-size: 1.5em">OpenView</b>
          </router-link>
        </div>

        <div class="navbar-menu">
          <div class="navbar-start">
            <router-link class="navbar-item" :to="{ name: 'customers.index' }">
              Clienti
            </router-link>

            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                Catalogo
              </a>
              <div class="navbar-dropdown">
                <router-link
                  class="navbar-item"
                  :to="{ name: 'products.index' }"
                >
                  Prodotti
                </router-link>
                <router-link
                  class="navbar-item"
                  :to="{ name: 'productTypes.index' }"
                >
                  Tipologie di prodotto
                </router-link>
                <router-link
                  class="navbar-item"
                  :to="{ name: 'contractTypes.index' }"
                >
                  Tipologie di contratto
                </router-link>
                <router-link class="navbar-item"
                  :to="{ name: 'courseTypes.index' }"
                  >Tipologie di corso
                </router-link>
              </div>
            </div>

            <!-- <router-link class="navbar-item" :to="{ name: 'products.index' }">
              Prodotti
            </router-link>
            <router-link
              class="navbar-item"
              :to="{ name: 'productTypes.index' }"
            >
              Tipologie prodotto
            </router-link>
            <router-link
              class="navbar-item"
              :to="{ name: 'contractTypes.index' }"
            >
              Tipologie contratto
            </router-link> -->
            <router-link class="navbar-item" :to="{ name: 'estimates.index' }">
              Preventivi
            </router-link>
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                Cerca
              </a>
              <div class="navbar-dropdown">
                <router-link
                  class="navbar-item"
                  :to="{ name: 'supportContracts.index' }"
                >
                  Contratti di assistenza
                </router-link>
                <router-link
                  class="navbar-item"
                  :to="{ name: 'productContracts.index' }"
                >
                  Contratti prodotto
                </router-link>
                <router-link
                  class="navbar-item"
                  :to="{ name: 'courseContracts.index' }"
                >
                  Corsi
                </router-link>
                <router-link
                  class="navbar-item"
                  :to="{ name: 'marketingActions.index' }"
                >
                  Azioni marketing
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="navbar-end">
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">{{ account.username }}</a>

            <div class="navbar-dropdown">
              <!-- <router-link
                :to="{ name: 'account.index' }"
                active-class="active"
                class="navbar-item">
                Account
              </router-link>-->
              <a class="navbar-item" href="#" @click.prevent="logout">
                <b-icon icon="sign-out-alt" size="is-small" />
                <span>Logout</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div id="main" class="container is-fullhd">
      <b-loading
        :is-full-page="false"
        :active.sync="loading"
        style="padding: 50px"
      />
      <div class="columns is-variable is-5">
        <!-- <div class="column is-narrow"><sidebar /></div> -->
        <div class="column">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* ============
 * Default Layout
 * ============
 *
 * Used for the home and account pages.
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */
import { get, call } from "vuex-pathify"
import Sidebar from "@/components/Sidebar"

export default {
  name: "MainLayout",
  components: { Sidebar },
  data() {
    return {
      loading: true,
      menuCollapsed: false
    }
  },
  async mounted() {
    // If the user is authenticated,
    // fetch the data from the API
    if (
      this.$store.state.auth.authenticated &&
      !this.$store.state.auth.account.id
    ) {
      await this.find()
      this.loading = false
    } else {
      this.loading = false
    }
  },
  computed: {
    account: get("auth/account")
  },
  methods: {
    find: call("auth/find"),
    logout: call("auth/logout"),
    toggleMenu() {
      this.menuCollapsed = !this.menuCollapsed
    }
  }
}
</script>

<style lang="sass" scoped>
#main
  margin-top: 1em

.navbar-dropdown .icon
  margin-right: 0.2em
</style>
